import _ from 'lodash';
import type { Op } from 'quill/core';
import React, { useRef, useState } from 'react';
import RichTextDescriptionEditor from '../editor/RichTextDescriptionEditor';
import deltaOnlyContainWhitespace from '../utils/deltaOnlyContainWhitespace';
import CollapsibleContent from './CollapsibleContent';

interface TopicOrUserCollapsibleContentProps {
  content?: Op[];
  collapsed: boolean;
  onCollapsedChange: (collapsed: boolean) => void;
  testId?: string;
}

const TopicOrUserCollapsibleContent = ({
  content,
  collapsed,
  onCollapsedChange,
  testId,
}: TopicOrUserCollapsibleContentProps) => {
  const contentRef = useRef(content);
  const [key, setKey] = useState(0);

  if (!_.isEqual(contentRef.current, content)) {
    contentRef.current = content;
    setKey((prev) => prev + 1);
  }

  return (
    <>
      {content && !deltaOnlyContainWhitespace(content) && (
        <CollapsibleContent
          maxHeight={180}
          collapsed={collapsed}
          onCollapsedChange={onCollapsedChange}
          key={key}
        >
          {(onContentChange) => (
            <RichTextDescriptionEditor
              readOnly
              noTitleLine
              namespace="topicUserDescription"
              defaultValue={content}
              onTextChange={onContentChange}
              onMount={onContentChange}
              testId={testId}
            />
          )}
        </CollapsibleContent>
      )}
    </>
  );
};

export default TopicOrUserCollapsibleContent;
